import { List, ListItem, Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface ILanguages {
  languagesList: string[];
}

export const Languages = ({ languagesList }: ILanguages) => {
  const listItemSx: SxProps = {
    p: '0 0 0 8px',
    '&::before': {
      content: '"\\2022"',
      fontSize: '20px',
      marginRight: '8px',
    },
  };

  if (languagesList.length === 0) return null;

  return (
    <Stack
      gap='8px'
      sx={{
        width: '100%',
        maxWidth: '307px',
      }}
    >
      <Typography variant='body5'>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.languages}
      </Typography>
      <List sx={{ listStyleType: 'disc', listStylePosition: 'inside', p: 0 }}>
        {languagesList.map((language: string, index: number) => {
          return (
            <ListItem key={index} sx={{ ...listItemSx }}>
              <Typography variant='body3'>{language}</Typography>
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
};
